import { ACTIONS } from '../ActionTypes';

// TODO: This is an example
export const exampleFetch = () => ({ type: ACTIONS.EXAMPLE.FETCH });

export const exampleSuccess = (data: object) => ({ type: ACTIONS.EXAMPLE.SUCCESS, payload: { data } });

export const exampleFail = (error: object) => ({ type: ACTIONS.EXAMPLE.FAIL, payload: error });
